import React from 'react'

import { SavedCreditCardPicker } from '../../SavedCreditCardPicker/SavedCreditCardPicker'
import Fieldset from '../../Modifiers/Fieldset/Fieldset'
import { Field, Formik, Form } from 'formik'
import Button from '../../Button/Button'
import { useCreditCard } from '../../CreditCardProvider/CreditCardProvider'
import Error from '../../Error/Error'
import { logError } from '../../Error/error-utils'

import { getPrimaryCreditCard } from '../../../utils/form-utils'

import './SavedCreditCardForm.css'
import { toast } from 'react-toastify'

export const SavedCreditCardForm = () => {
  const { creditCards = [], makePrimary } = useCreditCard()
  const savedCardGuid = getPrimaryCreditCard(creditCards).guid || ''

  let fieldsetLabel = 'Payment Options'

  if (creditCards.length >= 3) {
    fieldsetLabel = (
      <div styleName='stacked-label'>
        <span>Payment Options</span>
        <span styleName='label-message'>Three card max has been reached</span>
      </div>
    )
  }

  return (
    <Fieldset label={fieldsetLabel} collapsable>
      <Formik
        initialValues={{ savedCardGuid }}
        onSubmit={async (values, { setSubmitting }) => {
          const input = {
            cardGuid: values.savedCardGuid
          }

          try {
            await makePrimary.mutate({ variables: { input } })
            toast('Primary Card Updated Successfully!')
          } catch (err) {
            logError(err)
          } finally {
            setSubmitting(false)
          }
        }}
        enableReinitialize>
        {({isSubmitting, dirty, isValid, handleSubmit}) => {
          return (
            <Form>
              <Field
                component={SavedCreditCardPicker}
                name='savedCardGuid'
                creditCards={creditCards}
                isDeletable
              />
              <div styleName='submitWrapper'>
                {makePrimary.result.error && <Error error={makePrimary.result.error} />}
                <Button
                  eventData={{
                    category: 'User Account',
                    action: 'Make Primary Credit Card'
                  }}
                  data-testid='button-submit-primary-credit-card'
                  id='SubmitPrimaryCreditCardButton'
                  style='primary'
                  type='submit'
                  onClick={event => {
                    event.preventDefault()
                    handleSubmit()
                  }}
                  loading={isSubmitting}
                  disabled={!dirty || !isValid}
                  responsive>
                    Update My Primary Card
                </Button>
              </div>
            </Form>
          )
        }}
      </Formik>
    </Fieldset>
  )
}

export default SavedCreditCardForm
